var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5206 20.2451H5.27057V21.7451H22.5206V20.2451Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5506 7.87505L14.6106 1.93505C14.0206 1.34505 13.0706 1.34505 12.4906 1.93505L1.99057 12.4351C1.40057 13.0251 1.40057 13.9751 1.99057 14.5551L5.37056 17.9851H12.5606L20.5506 9.99505C21.1406 9.40505 21.1406 8.45505 20.5506 7.87505ZM11.9406 16.4951H6.02057L3.02057 13.4951L7.75057 8.76505L13.7006 14.7051L11.9406 16.4951ZM14.7606 13.6751L8.82057 7.72505L13.5206 2.99505L19.5206 8.94505L14.7606 13.6751Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipDraft);
export default __webpack_public_path__ + "static/media/ic-chip-draft.d885ac037ea537df0c15843dba95a6e0.svg";
export { ForwardRef as ReactComponent };